import { LoginService } from "./LoginService";
import { ServiceConsts } from "./ServiceConsts";
import { ApiService } from "./ApiService";

export class NotificationService {
    static async getNotifications(count, after) {
        return ApiService.get(
            ServiceConsts.API_URL + "/notifications",
            "count=" + count + (after ? "&before=" + after : ""),
        );
    }

    static async getUnreadNotificationsCount() {
        return ApiService.get(ServiceConsts.API_URL + "/notifications/unread");
    }

    static async markNotificationsRead(before) {
        return ApiService.put(
            ServiceConsts.API_URL + "/notifications/read?before=" + before,
        );
    }

    static async subscribeTopicNotifications(topicId) {
        return ApiService.put(
            ServiceConsts.API_URL +
                "/notifications/topics/" +
                topicId +
                "/subscribe",
        );
    }

    static async unsubscribeTopicNotifications(topicId) {
        return ApiService.put(
            ServiceConsts.API_URL +
                "/notifications/topics/" +
                topicId +
                "/unsubscribe",
        );
    }

    static async getTopicNotificationSubscriptionStatus(topicId) {
        return ApiService.get(
            ServiceConsts.API_URL +
                "/notifications/topics/" +
                topicId +
                "/status",
        );
    }
}
